// Keep newest first — the page renders in this order.
// `date` is a display string; set the exact date when known.
// TODO: confirm exact publish dates for these Hashnode posts, and check the
// title/description for the top two — Hashnode blocks fetching, so both
// were inferred from the URL slug alone.

export const blogs = [
  {
    id: 9,
    title: "Web3 Will Win Only When It Feels Like Web2",
    description:
      "How zero-knowledge login flows and zkAuthenticator patterns let you sign into Web3 apps with familiar Web2 credentials, without giving up privacy.",
    link: "https://madhublogs.hashnode.dev/zklogin-and-zkauthenticator",
    date: "July 2025",
  },
  {
    id: 8,
    title: "What If Trust Was Something You Earned, Not Scanned?",
    description:
      "Rethinking digital identity and trust, and questioning why we default to scanning people to prove who they are instead of letting trust be earned over time.",
    link: "https://madhublogs.hashnode.dev/what-if-trust-was-something-you-earned-not-scanned",
    date: "June 2025",
  },
  {
    id: 7,
    title: "How I Built My End-to-End Web3 dApp?",
    description: "Check out if you want to build a web3 dapp right away!",
    link: "https://madhublogs.hashnode.dev/how-i-built-my-end-to-end-web3-dapp",
    date: "June 2025",
  },
  {
    id: 6,
    title: "Trust Me, I Can Prove It with ZK (No Details Needed)",
    description:
      "You don’t need to see everything to believe it happened. ZK isn't a bonus, it's your shield.",
    link: "https://madhublogs.hashnode.dev/zk",
    date: "May 2025",
  },
  {
    id: 5,
    title: "Web3’s New Power Couple: Restaking x ZK",
    description:
      "Just wait till restaking and ZK do their thing. Because the future? It’s modular, it’s secure, and it’s ZK-proven.",
    link: "https://madhublogs.hashnode.dev/restaking-x-zk",
    date: "May 2025",
  },
  {
    id: 4,
    title: "From Staking to Restaking: Blockchain Scaled",
    description:
      "Restaking isn’t just a buzzword. It’s part of a bigger move toward modular infrastructure, where flexibility and security go hand in hand.",
    link: "https://madhublogs.hashnode.dev/from-staking-to-restaking-blockchain-scaled",
    date: "May 2025",
  },
  {
    id: 3,
    title: "Blockchain Scalability: Why It Matters and How It’s Solved ?",
    description:
      "As more users join a Blockchain network (like Bitcoin or Ethereum), the system struggles to handle all the transactions, leading to delays and higher transaction fees.",
    link:
      "https://medium.com/@madhuvarsha0608/blockchain-scalability-why-it-matters-and-how-its-solved-d36eeb4a6400",
    date: "Nov 2024",
  },
  {
    id: 2,
    title: "Decentralized Apps : How They Work and Why They’re Game-Changers",
    description:
      "What are dApps, How do they work, and Why would they be supposed to be game-changers?",
    link:
      "https://medium.com/@madhuvarsha0608/decentralized-apps-how-they-work-and-why-theyre-game-changers-af427e5a353d",
    date: "Jul 2024",
  },
  {
    id: 1,
    title:
      "Charting Your Course in Blockchain: The Essential Roadmap for Beginners",
    description:
      "Are you a beginner struggling where to kick start in Blockchain technology? Then, check out this blog!",
    link:
      "https://medium.com/@madhuvarsha0608/charting-your-course-in-blockchain-the-essential-roadmap-for-beginners-99d8eb22c08a",
    date: "Jun 2024",
  },
];
